module.exports = __webpack_public_path__ + "0b0b0559ba3a921f1affd015df8a82f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/taiwan-12.png
// module id = 480
// module chunks = 0